import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiResult } from '../models/api/api-result.model';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private readonly apiUrl = environment.apiBaseUrl;
  private readonly apiVersion = environment.apiVersion;
  private readonly language = 'tr';

  constructor(private readonly http: HttpClient) {
  }

  get<TResponse>(endpoint: string, params?: HttpParams): Observable<ApiResult<TResponse>> {
    return this.http.get<ApiResult<TResponse>>(
      this.createUrl(endpoint),
      { params }
    );
  }

  post<TResponse, TRequest = unknown>(endpoint: string, request: TRequest): Observable<ApiResult<TResponse>> {
    return this.http.post<ApiResult<TResponse>>(
      this.createUrl(endpoint),
      request
    );
  }

  postnull<TResponse>(endpoint: string): Observable<ApiResult<TResponse>> {
    return this.http.post<ApiResult<TResponse>>(
      this.createUrl(endpoint),
      null
    );
  }

  put<TResponse, TRequest = unknown>(endpoint: string, request: TRequest): Observable<ApiResult<TResponse>> {
    return this.http.put<ApiResult<TResponse>>(
      this.createUrl(endpoint),
      request
    );
  }

  patch<TResponse, TRequest = unknown>(endpoint: string, request: TRequest): Observable<ApiResult<TResponse>> {
    return this.http.patch<ApiResult<TResponse>>(
      this.createUrl(endpoint),
      request
    );
  }

  delete<TResponse>(endpoint: string): Observable<ApiResult<TResponse>> {
    return this.http.delete<ApiResult<TResponse>>(
      this.createUrl(endpoint)
    );
  }

  private createUrl(endpoint: string): string {
    const normalizedEndpoint = endpoint.startsWith('/')
      ? endpoint.substring(1)
      : endpoint;

    return `${this.apiUrl}/api/${this.apiVersion}/${this.language}/${normalizedEndpoint}`;
  }
}